import type { FC } from "react";
import userIcon from "../image/user_image.png";
import logoutIcon from "../image/logout.png";
import { showConfirmMessage } from "../components/appPane";
import { ENV_TITLE_TEXT, MESSAGES } from "../constants/const";
import useCookie from "../logic/cookie";

interface Props {
  /** ログアウト操作ハンドラ */
  onLogout: () => void;
}

/**
 * ヘッダ表示
 * @param props
 * @returns
 */
const HeaderPanel: FC<Props> = ({ onLogout }) => {
  const [cookieData] = useCookie();
  const imgStyle = { marginLeft: "2rem" };
  // ログアウトボタン押下
  const logout = async () => {
    if (await showConfirmMessage(MESSAGES.CONFIRM_LOGOUT)) onLogout();
  };

  return (
    <div className="app-header">
      <div className="content">
        <div className="title">{`薬剤管理システム${ENV_TITLE_TEXT}`}</div>

        <div className="menu">
          <div className="user">
            <span>{cookieData.branchName}</span>
            <img src={userIcon} alt="button" style={imgStyle}></img>
            <span>{cookieData.userName}</span>
          </div>

          <div className="logout">
            <button onClick={logout}>
              <img src={logoutIcon} alt="button" />
              ログアウト
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderPanel;
